module.exports = __webpack_public_path__ + "img/z_y.de7bbbb0.png";